import './NavTab.scss';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ElementType, memo, PropsWithChildren, ReactElement } from 'react';

type PolymorphicProps<E extends ElementType> = PropsWithChildren<ComponentPropsWithoutRef<E> & {
  as?: E;
}>;

type NavTabProps<T extends React.ElementType> = PolymorphicProps<T> & PropsWithChildren<{
  selected?: boolean;
  disabled?: boolean;
}>;

const NavTabWithoutMemo = <T extends ElementType = 'button'>({
  as,
  selected,
  children,
  ...props
}: NavTabProps<T>): ReactElement => {
  const Component = as || 'button';

  return (
    <Component
      className={clsx({
        'bp-nav-tab': true,
        'bp-nav-tab--selected': selected,
        'bp-nav-tab--disabled': props.disabled,
      })}
      type={props.type || 'button'}
      {...props}
    >
      {children}
    </Component>
  );
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const NavTab = memo(NavTabWithoutMemo) as typeof NavTabWithoutMemo;
